import IdentityObject from "@/src/domain/common/identity-object";

export default abstract class NotificationService extends IdentityObject {
  abstract isSupported(): boolean;
  abstract isRegistered(): boolean;
  abstract registerForPushNotifications(): Promise<void>;
  abstract unregisterPushNotifications(): Promise<void>;
}
